module.exports = __webpack_public_path__ + "img/guide22.7d1cf900.png";